'use strict';

const ERP_ERROR_LABELS = {
  1: 'Saldo de Estoque',
  2: 'Período Bloqueado',
  3: 'Chave Estrangeira',
  4: 'Master Não Encontrado',
  5: 'Validação do Modelo'
};

const PERIODO_OPTIONS = [
  { label: 'Últimos 10 dias', value: '10dias' },
  { label: 'Últimos 15 dias', value: '15dias' },
  { label: 'Período customizado', value: 'customizado' }
];

const STATUS_OPTIONS = [
  { label: 'Todos', value: 'todos' },
  { label: 'Erro', value: 'erro' },
  { label: 'Pendente', value: 'pendente' }
];

const MIN_SEARCH_LENGTH = 3;
const SEARCH_DEBOUNCE_MS = 750;
const MAX_RETRY_COUNT = 5;

const REDIRECT_MODELS = {
  Aplicacao: 'aplicacao',
  AplicacaoItem: 'aplicacao',
  MovimentoEstoqueTransferencia: 'tratamento_semente',
  MovimentoEstoqueTransferenciaItem: 'tratamento_semente',
  Gleba: 'talhao',
  PrestacaoServico: 'uso_maquina'
};

const REGISTRO_INDISPONIVEL_MSG =
  'Não foi possível localizar o lançamento.';

function pad2(n) {
  return n < 10 ? `0${n}` : String(n);
}

function toIsoDate(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return '';
  }
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}


function escapeHtml(str) {
  if (!str) {
    return '';
  }
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function formatCodigoErro(codigo) {
  if (!codigo) {
    return null;
  }
  const label = ERP_ERROR_LABELS[String(codigo)];
  return label ? `${codigo} – ${label}` : String(codigo);
}

function formatarData(dataStr) {
  if (!dataStr) {
    return '-';
  }
  const d = new Date(dataStr);
  if (isNaN(d.getTime())) {
    return '-';
  }
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
  });
}

function excedeuLimiteRetry(erro) {
  return erro.retryCount >= MAX_RETRY_COUNT;
}

function buildTooltipHtml(erro, sce) {
  const lines = [];
  function addLine(label, value) {
    if (!value) {
      return;
    }
    lines.push(`<div>${escapeHtml(label)} <b>${escapeHtml(String(value))}</b></div>`);
  }
  addLine('ID:', erro.idLocal);
  addLine('Propriedade:', erro.propriedade);
  addLine('Model:', erro.model);
  addLine('Operação:', erro.operacaoDescricao);
  addLine('Data do Lançamento:', erro.dataRegistro);
  addLine('Talhão:', erro.talhaoDescricao);
  addLine('Atividade:', erro.atividadeDescricao);
  addLine('Cultivar:', erro.cultivarDescricao);
  addLine('Depósito de Origem:', erro.depositoOrigem);
  addLine('Depósito de Destino:', erro.depositoDestino);
  addLine('Pluviômetro:', erro.pluviometroDescricao);
  addLine('Máquina:', erro.maquinaDescricao);
  addLine('Quantidade de Chuva:', erro.quantidadeChuva);
  addLine('Origem:', erro.origem);
  addLine('Data do Erro:', formatarData(erro.dataOperacao));
  addLine('Código do Erro:', formatCodigoErro(erro.codigoErro));
  addLine('Mensagem de Erro:', erro.mensagemErro);
  return sce.trustAsHtml(`<div class="erros-integracao-tooltip-content">${lines.join('')}</div>`);
}

function periodoLabelCustomizado(range) {
  if (range.length !== 2 || !range[0] || !range[1]) {
    return 'Período';
  }
  const currentYear = new Date().getFullYear();
  const fmt = (iso) => {
    const d = new Date(`${iso}T00:00:00`);
    if (isNaN(d.getTime())) {
      return null;
    }
    const opts = d.getFullYear() !== currentYear ?
      { day: '2-digit', month: '2-digit', year: 'numeric' } :
      { day: '2-digit', month: '2-digit' };
    return d.toLocaleDateString('pt-BR', opts);
  };
  const from = fmt(range[0]);
  const to = fmt(range[1]);
  return from && to ? `${from} – ${to}` : 'Período';
}

function getPeriodoLabel(periodoAplicado) {
  if (!periodoAplicado || !periodoAplicado.modo) {
    return 'Período';
  }
  if (periodoAplicado.modo === '10dias') {
    return 'Últ. 10 dias';
  }
  if (periodoAplicado.modo === '15dias') {
    return 'Últ. 15 dias';
  }
  if (periodoAplicado.modo === 'customizado') {
    return periodoLabelCustomizado(periodoAplicado.range || []);
  }
  return 'Período';
}

function periodoRangeRelative(days) {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - days);
  return { start, end };
}

function periodoRangeCustomizado(range) {
  if (!range[0] || !range[1]) {
    return null;
  }
  const start = new Date(`${range[0]}T00:00:00`);
  const end = new Date(`${range[1]}T23:59:59`);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return null;
  }
  return { start, end };
}

function getPeriodoRange(periodoAplicado) {
  if (!periodoAplicado || !periodoAplicado.modo) {
    return null;
  }
  if (periodoAplicado.modo === '10dias') {
    return periodoRangeRelative(10);
  }
  if (periodoAplicado.modo === '15dias') {
    return periodoRangeRelative(15);
  }
  if (periodoAplicado.modo === 'customizado') {
    return periodoRangeCustomizado(periodoAplicado.range || []);
  }
  return null;
}

function sanitizeSearch(text) {
  return (text || '')
    .trim()
    .replace(/<[^>]*>/g, '')
    .replace(/[<>"'`]/g, '');
}

function buildRequestParams(vm) {
  const params = {};
  const search = sanitizeSearch(vm.textInput);
  if (search.length >= MIN_SEARCH_LENGTH) {
    params.search = search;
  }
  if (vm.statusFilter && vm.statusFilter !== 'todos') {
    params.status = vm.statusFilter;
  }
  const range = getPeriodoRange(vm.periodoAplicado);
  if (range) {
    params.from = range.start.toISOString();
    params.to = range.end.toISOString();
  }
  return params;
}

function getErroCount(summary) {
  return ((summary || {}).by_status || {}).erro || 0;
}

function hasActiveFilters(params) {
  return !!(params.search || params.status || params.from || params.to);
}

function applyListResult({ result, params, env, append }) {
  const { vm, deps } = env;
  const novos = (result.data || [])
    .filter((rec) => !params.status || rec.status === params.status)
    .map((rec) => {
      rec._tooltipHtml = buildTooltipHtml(rec, deps.$sce);
      rec._limiteRetry = excedeuLimiteRetry(rec);
      return rec;
    });
  vm.erros = append ? vm.erros.concat(novos) : novos;
  vm.pagination = result.pagination;
  if (!append && !hasActiveFilters(params)) {
    const errCount = getErroCount(result.summary);
    vm.totalErrosCount = errCount;
    deps.$rootScope.integrationErrorsCount = errCount;
  }
}

function calcularStatusParaCarregar(paginasPendentes, append) {
  const paginaErro = append ? paginasPendentes.erro : 1;
  const paginaPendente = append ? paginasPendentes.pendente : 1;
  const statusParaCarregar = [];
  if (paginaErro) {
    statusParaCarregar.push({ status: 'erro', page: paginaErro });
  }
  if (paginaPendente) {
    statusParaCarregar.push({ status: 'pendente', page: paginaPendente });
  }
  return statusParaCarregar;
}

function processarRespostasTodos(resultados, statusParaCarregar, contexto) {
  const { env, append } = contexto;
  const { vm, deps } = env;
  if (!vm._pendingPages) {
    vm._pendingPages = {};
  }
  statusParaCarregar.forEach((busca, indice) => {
    const paginacao = resultados[indice].pagination;
    vm._pendingPages[busca.status] = (paginacao && paginacao.next_page) ? paginacao.next_page : null;
  });
  const registros = [];
  resultados.forEach((resultado) => {
    (resultado.data || []).forEach((registro) => {
      registro._tooltipHtml = buildTooltipHtml(registro, deps.$sce);
      registro._limiteRetry = excedeuLimiteRetry(registro);
      registros.push(registro);
    });
  });
  registros.sort((a, b) => new Date(b.dataOperacao) - new Date(a.dataOperacao));
  vm.erros = append ? vm.erros.concat(registros) : registros;
}

function carregarErrosTodos(env, extra) {
  const { vm, deps } = env;
  const append = !!(extra && extra.append);
  const base = buildRequestParams(vm);
  const statusParaCarregar = calcularStatusParaCarregar(vm._pendingPages || {}, append);

  if (!statusParaCarregar.length) {
    return deps.$q.resolve();
  }

  const montarParams = (busca) => ({ ...base, status: busca.status, page: busca.page });
  const promises = statusParaCarregar.map((busca) => deps.SyncAgrogestaoService.list(montarParams(busca)));

  return deps.$q.all(promises).then((resultados) => {
    processarRespostasTodos(resultados, statusParaCarregar, { env, append });
  });
}

function carregarBadgeCount(env) {
  env.deps.SyncAgrogestaoService.list({})
    .then((result) => {
      const errCount = getErroCount(result.summary);
      env.vm.totalErrosCount = errCount;
      env.deps.$rootScope.integrationErrorsCount = errCount;
    })
    .catch(angular.noop);
}

function carregarErros(env, extra) {
  const { vm } = env;
  const append = !!(extra && extra.append);
  if (append) {
    vm.isLoadingMore = true;
  } else {
    vm.isLoading = true;
    vm.erros = [];
    vm._pendingPages = null;
  }

  const doLoad = vm.statusFilter === 'todos' ?
    carregarErrosTodos(env, extra) :
    (() => {
      const params = { ...buildRequestParams(vm), ...(extra ? extra.params || {} : {}) };
      return env.deps.SyncAgrogestaoService.list(params)
        .then((result) => applyListResult({ result, params, env, append }));
    })();

  return doLoad
    .catch((err) => console.error('Erro ao carregar erros de integração:', err))
    .finally(() => {
      vm.isLoading = false;
      vm.isLoadingMore = false;
    });
}

function buildCopyText(erro) {
  const lines = [];
  function addLine(label, value) {
    if (!value) {
      return;
    }
    lines.push(`${label} ${String(value)}`);
  }
  addLine('ID:', erro.idLocal);
  addLine('Propriedade:', erro.propriedade);
  addLine('Model:', erro.model);
  addLine('Operação:', erro.operacaoDescricao);
  addLine('Data do Lançamento:', erro.dataRegistro);
  addLine('Talhão:', erro.talhaoDescricao);
  addLine('Atividade:', erro.atividadeDescricao);
  addLine('Cultivar:', erro.cultivarDescricao);
  addLine('Depósito de Origem:', erro.depositoOrigem);
  addLine('Depósito de Destino:', erro.depositoDestino);
  addLine('Pluviômetro:', erro.pluviometroDescricao);
  addLine('Máquina:', erro.maquinaDescricao);
  addLine('Quantidade de Chuva:', erro.quantidadeChuva);
  addLine('Origem:', erro.origem);
  addLine('Data do Erro:', formatarData(erro.dataOperacao));
  addLine('Código do Erro:', formatCodigoErro(erro.codigoErro));
  addLine('Mensagem de Erro:', erro.mensagemErro);
  return lines.join('\n');
}

function copyToClipboard(text, done) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(done);
    return;
  }
  const el = document.createElement('textarea');
  el.value = text;
  el.style.position = 'fixed';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  done();
}

function copiarErro(erro, env) {
  const text = buildCopyText(erro);
  copyToClipboard(text, function() {
    erro._copied = true;
    env.deps.$timeout(function() {
      erro._copied = false;
    }, 2000);
  });
}

function onResyncSuccess(id, env) {
  const { vm, deps } = env;
  const item = vm.erros.filter((rec) => rec.id === id)[0];
  if (item) {
    item.status = 'pendente';
    item.syncing = false;
  }
  vm.totalErrosCount = Math.max(vm.totalErrosCount - 1, 0);
  deps.$rootScope.integrationErrorsCount = vm.totalErrosCount;
}

function ressincronizarErro(erro, env) {
  if (erro.syncing || erro._limiteRetry) {
    return;
  }
  erro.syncing = true;
  env.deps.SyncAgrogestaoService.reprocessar(erro.id)
    .then(() => onResyncSuccess(erro.id, env))
    .catch((err) => {
      console.error('Erro ao ressincronizar:', err);
      erro.syncing = false;
      env.deps.MessagesService.alert('Não foi possível ressincronizar o registro. Tente novamente.');
    });
}

function getRedirectTipo(erro) {
  return REDIRECT_MODELS[(erro.model || '').trim()] || null;
}

function podeRedirecionar(erro) {
  return !!getRedirectTipo(erro);
}

function possuiIdentificadores(tipo, erro) {
  if (tipo === 'uso_maquina') {
    return !!erro.cdPropriedade;
  }
  return !!(erro.cdPropriedade && erro.idLocal);
}

function fecharDropdownPrincipal(env) {
  env.element.closest('.dropdown').removeClass('open');
}

function irParaPropriedade(cdPropriedade, { search } = {}, env) {
  const { $rootScope, $location, $timeout } = env.deps;
  $rootScope.setPropriedade(Number(cdPropriedade));
  $timeout(() => {
    $location.path('/propriedade').search({
      propriedade: cdPropriedade,
      activeGleba: null,
      gleba: null,
      ...search
    });
  });
  fecharDropdownPrincipal(env);
}

function verificarERedirecionar(erro, env, { verificar, navegar }) {
  erro._redirecting = true;
  verificar()
    .then(navegar)
    .catch(() => env.deps.MessagesService.alert(REGISTRO_INDISPONIVEL_MSG))
    .finally(() => {
      erro._redirecting = false;
    });
}

function redirecionarTalhao(erro, env) {
  verificarERedirecionar(erro, env, {
    verificar: () => env.deps.GlebasService.get(erro.idLocal).then((response) => {
      if (!(response.data || {}).id) {
        throw new Error('Talhão não encontrado');
      }
    }),
    navegar: () => {
      env.deps.$location.path(`/glebas/${erro.idLocal}`);
      fecharDropdownPrincipal(env);
    }
  });
}

function redirecionarUsoMaquina(erro, env) {
  irParaPropriedade(erro.cdPropriedade, {
    search: { sidebar: 'usosMaquinas', activeUsoMaquina: erro.idLocal }
  }, env);
}

function redirecionarTratamentoSemente(erro, env) {
  irParaPropriedade(erro.cdPropriedade, {
    search: {
      sidebar: 'applications',
      activeApplicationsTab: 'ts',
      activeApplication: erro.idLocal
    }
  }, env);
}

function redirecionarAplicacao(erro, env) {
  verificarERedirecionar(erro, env, {
    verificar: () => env.deps.AplicacoesService.get(erro.idLocal),
    navegar: () => irParaPropriedade(erro.cdPropriedade, {
      search: { sidebar: 'editApplication', activeApplication: erro.idLocal }
    }, env)
  });
}

function redirecionarErro(erro, env) {
  if (erro._redirecting) {
    return;
  }
  const tipo = getRedirectTipo(erro);
  if (!tipo || !possuiIdentificadores(tipo, erro)) {
    env.deps.MessagesService.alert(REGISTRO_INDISPONIVEL_MSG);
    return;
  }
  if (tipo === 'aplicacao') {
    redirecionarAplicacao(erro, env);
    return;
  }
  if (tipo === 'tratamento_semente') {
    redirecionarTratamentoSemente(erro, env);
    return;
  }
  if (tipo === 'uso_maquina') {
    redirecionarUsoMaquina(erro, env);
    return;
  }
  redirecionarTalhao(erro, env);
}

function makeDropdownToggle(openKey, offKey) {
  function fechar(env) {
    env.vm[openKey] = false;
    env.ctx[offKey]();
    env.ctx[offKey] = angular.noop;
  }

  function toggle($event, env) {
    $event.stopPropagation();
    if (env.vm[openKey]) {
      fechar(env);
      return;
    }
    env.vm[openKey] = true;
    env.deps.$timeout(function() {
      const handler = function() {
        env.deps.$document.off('click', handler);
        env.deps.$rootScope.$apply(() => fechar(env));
      };
      env.deps.$document.on('click', handler);
      env.ctx[offKey] = () => env.deps.$document.off('click', handler);
    }, 0);
  }

  return { fechar, toggle };
}

const periodoDropdown = makeDropdownToggle('periodoOpen', 'offPeriodoClickOutside');
const statusDropdown = makeDropdownToggle('statusOpen', 'offStatusClickOutside');

function applyCustomPeriodo(tempFilters, env) {
  if (!tempFilters.dataInicial || !tempFilters.dataFinal) {
    return;
  }
  if (tempFilters.dataFinal < tempFilters.dataInicial) {
    env.deps.MessagesService.alert('A data final não pode ser anterior à data inicial.');
    return;
  }
  const range = [toIsoDate(tempFilters.dataInicial), toIsoDate(tempFilters.dataFinal)];
  env.vm.periodoAplicado = { modo: 'customizado', range };
  env.vm.periodoLabel = getPeriodoLabel(env.vm.periodoAplicado);
  carregarErros(env);
}

function openCustomPeriodo(env) {
  const dropdownEl = env.element.closest('.dropdown');

  const preventClose = function(e) {
    e.preventDefault();
  };
  dropdownEl.on('hide.bs.dropdown', preventClose);

  const stopBodyPropagation = function(e) {
    const dlg = document.querySelector('.period-select-modal .modal-dialog');
    if (dlg && dlg.contains(e.target)) {
      e.stopPropagation();
    }
  };
  document.body.addEventListener('click', stopBodyPropagation);

  const r = env.vm.periodoAplicado.range || [];
  const tempFilters = {
    dataInicial: r[0] ? new Date(`${r[0]}T00:00:00`) : null,
    dataFinal: r[1] ? new Date(`${r[1]}T00:00:00`) : null
  };
  env.deps.PeriodSelectService
    .openPeriodSelection({ periodo: '', eventDates: [] }, tempFilters)
    .then(() => applyCustomPeriodo(tempFilters, env))
    .catch(angular.noop)
    .finally(function() {
      setTimeout(function() {
        dropdownEl.off('hide.bs.dropdown', preventClose);
        document.body.removeEventListener('click', stopBodyPropagation);
      }, 0);
    });
}

function setPeriodo(modo, $event, env) {
  $event.preventDefault();
  $event.stopPropagation();
  if (modo === 'customizado') {
    periodoDropdown.fechar(env);
    openCustomPeriodo(env);
    return;
  }
  env.vm.periodoAplicado = { modo, range: [] };
  env.vm.periodoLabel = getPeriodoLabel(env.vm.periodoAplicado);
  periodoDropdown.fechar(env);
  carregarErros(env);
}

function clearPeriodo($event, env) {
  $event.preventDefault();
  $event.stopPropagation();
  env.vm.periodoAplicado = { modo: null, range: [] };
  env.vm.periodoLabel = 'Período';
  periodoDropdown.fechar(env);
  carregarErros(env);
}

function getStatusLabel(value) {
  const opt = STATUS_OPTIONS.filter((o) => o.value === value)[0];
  return opt ? opt.label : 'Status';
}

function setStatus(value, $event, env) {
  $event.preventDefault();
  $event.stopPropagation();
  env.vm.statusFilter = value;
  env.vm.statusLabel = getStatusLabel(value);
  statusDropdown.fechar(env);
  carregarErros(env);
}

function makeEnv(vm, deps, element) {
  const ctx = { debounceTimer: null, offPeriodoClickOutside: angular.noop, offStatusClickOutside: angular.noop };
  return { vm, deps, element, ctx };
}

function initVm(scope) {
  scope.vm = {
    erros: [],
    isLoading: false,
    isLoadingMore: false,
    pagination: null,
    _pendingPages: null,
    totalErrosCount: 0,
    textInput: '',
    statusFilter: 'erro',
    statusLabel: getStatusLabel('erro'),
    statusOpen: false,
    periodoAplicado: { modo: null, range: [] },
    periodoLabel: 'Período',
    periodoOpen: false,
    periodoOptions: PERIODO_OPTIONS,
    statusOptions: STATUS_OPTIONS
  };
}

function onDestroy(env) {
  if (env.ctx.debounceTimer) {
    env.deps.$timeout.cancel(env.ctx.debounceTimer);
  }
  periodoDropdown.fechar(env);
  statusDropdown.fechar(env);
}

function setupSearch(env) {
  const { vm, ctx, deps } = env;
  vm.onTextInputChange = function() {
    if (ctx.debounceTimer) {
      deps.$timeout.cancel(ctx.debounceTimer);
    }
    ctx.debounceTimer = deps.$timeout(() => carregarErros(env), SEARCH_DEBOUNCE_MS);
  };
  vm.clearTextInput = function() {
    vm.textInput = '';
    if (ctx.debounceTimer) {
      deps.$timeout.cancel(ctx.debounceTimer);
    }
    carregarErros(env);
  };
}

function setupStatus(env) {
  const { vm } = env;
  vm.toggleStatus = ($event) => statusDropdown.toggle($event, env);
  vm.setStatus = (value, $event) => setStatus(value, $event, env);
}

function setupPeriodo(env) {
  const { vm } = env;
  vm.togglePeriodo = ($event) => periodoDropdown.toggle($event, env);
  vm.setPeriodo = (modo, $event) => setPeriodo(modo, $event, env);
  vm.clearPeriodo = ($event) => clearPeriodo($event, env);
}

function carregarProximaPaginaTodos(vm, env) {
  const paginasPendentes = vm._pendingPages || {};
  if (!paginasPendentes.erro && !paginasPendentes.pendente) {
    return;
  }
  carregarErros(env, { append: true });
}

function setupList(env) {
  const { vm } = env;
  vm.carregarMais = function() {
    if (vm.isLoadingMore) {
      return;
    }
    if (vm.statusFilter === 'todos') {
      carregarProximaPaginaTodos(vm, env);
      return;
    }
    if (!vm.pagination || !vm.pagination.next_page) {
      return;
    }
    carregarErros(env, { params: { page: vm.pagination.next_page }, append: true });
  };
  vm.hasNextPage = () => {
    if (vm.statusFilter === 'todos') {
      const pages = vm._pendingPages || {};
      return !!(pages.erro || pages.pendente);
    }
    return vm.pagination && !!vm.pagination.next_page;
  };
}

function setupActions(env) {
  const { vm } = env;
  vm.copiar = (erro) => copiarErro(erro, env);
  vm.ressincronizar = (erro) => ressincronizarErro(erro, env);
  vm.podeRedirecionar = podeRedirecionar;
  vm.redirecionar = (erro) => redirecionarErro(erro, env);
  vm.formatarData = formatarData;
}

function buildLink(deps) {
  return function link(scope, element) {
    initVm(scope);
    const env = makeEnv(scope.vm, deps, element);
    setupSearch(env);
    setupStatus(env);
    setupPeriodo(env);
    setupList(env);
    setupActions(env);
    deps.$rootScope.initialize.then(() => {
      carregarBadgeCount(env);
      carregarErros(env);

      const $dropdown = element.closest('.dropdown');
      $dropdown.on('show.bs.dropdown', () => {
        deps.$rootScope.$apply(() => carregarErros(env));
      });
      scope.$on('$destroy', () => $dropdown.off('show.bs.dropdown'));
    });
    scope.$on('$destroy', () => onDestroy(env));
  };
}

ErrosIntegracao.$inject = ['$injector'];

function ErrosIntegracao($injector) {
  const $rootScope = $injector.get('$rootScope');
  const $timeout = $injector.get('$timeout');
  const $sce = $injector.get('$sce');
  const $document = $injector.get('$document');
  const $q = $injector.get('$q');
  const $location = $injector.get('$location');
  const SyncAgrogestaoService = $injector.get('SyncAgrogestaoService');
  const MessagesService = $injector.get('MessagesService');
  const PeriodSelectService = $injector.get('PeriodSelectService');
  const AplicacoesService = $injector.get('AplicacoesService');
  const GlebasService = $injector.get('GlebasService');
  const deps = {
    $rootScope,
    $timeout,
    $sce,
    $document,
    $q,
    $location,
    SyncAgrogestaoService,
    MessagesService,
    PeriodSelectService,
    AplicacoesService,
    GlebasService
  };
  return { restrict: 'E', templateUrl: 'views/erros_integracao/panel.html', scope: {}, link: buildLink(deps) };
}

angular.module('webAgro1App').directive('errosIntegracao', ErrosIntegracao);
